import { PropertyType as PropertyTypeEnum, RoomIconName } from '@/entities/room'

type PropertyType = {
  title: string
  value: PropertyTypeEnum
  icon: RoomIconName
}

export const PROPERTY_TYPES: PropertyType[] = [
  {
    title: '오피스텔',
    value: PropertyTypeEnum.OFFICETEL,
    icon: 'officetel',
  },
  {
    title: '아파트',
    value: PropertyTypeEnum.APARTMENT,
    icon: 'apartment',
  },
  {
    title: '연립빌라',
    value: PropertyTypeEnum.VILLA,
    icon: 'villa',
  },
  {
    title: '단독주택',
    value: PropertyTypeEnum.DETACHED,
    icon: 'detached',
  },
  {
    title: '원룸건물',
    value: PropertyTypeEnum.STUDIO,
    icon: 'studio',
  },
  {
    title: '상가주택',
    value: PropertyTypeEnum.MIXED_USE,
    icon: 'mixedUse',
  },
  {
    title: '고시원',
    value: PropertyTypeEnum.GOSIWON,
    icon: 'gosiwon',
  },
  {
    title: '호텔',
    value: PropertyTypeEnum.HOTEL,
    icon: 'hotel',
  },
  {
    title: '쉐어\n하우스',
    value: PropertyTypeEnum.SHARE_HOUSE,
    icon: 'shareHouse',
  },
  {
    title: '펜션',
    value: PropertyTypeEnum.VACATION_HOME,
    icon: 'vacationHome',
  },
  {
    title: '게스트\n하우스',
    value: PropertyTypeEnum.GUEST_HOUSE,
    icon: 'guestHouse',
  },
  {
    title: '모텔여관',
    value: PropertyTypeEnum.MOTEL,
    icon: 'motel',
  },
]
